import { Award, CheckCircle2, Droplets, ShieldCheck, Sparkles, Wrench } from 'lucide-react'
import { coatingIncludes } from '../../data/protection-catalog'

const includeIcons = [Droplets, Wrench, Sparkles, ShieldCheck, CheckCircle2, Award]

export interface CoatingIncludesSectionProps {
  id?: string
}

export function CoatingIncludesSection({
  id = 'ceramic-process',
}: Readonly<CoatingIncludesSectionProps>) {
  return (
    <section className="coating-includes-section" id={id} aria-labelledby="coating-includes-heading">
      <div className="section-container">
        <div className="center-heading">
          <p className="eyebrow">Included With Every Coating</p>
          <h2 id="coating-includes-heading">Every Ceramic Coating Includes</h2>
        </div>
        <div className="compact-icon-grid">
          {coatingIncludes.map((item, index) => {
            const Icon = includeIcons[index] ?? CheckCircle2
            return (
              <article key={item}>
                <Icon aria-hidden="true" size={24} />
                <h3>{item}</h3>
              </article>
            )
          })}
        </div>
      </div>
    </section>
  )
}
